module.exports = __webpack_public_path__ + "img/9788958073253.9724b37d.jpg";